import { jsx as n, jsxs as h } from "react/jsx-runtime";
import { Button as p } from "@telegraph/button";
import { Lucide as g, Icon as C } from "@telegraph/icon";
import { Stack as z } from "@telegraph/layout";
import { motion as f } from "@telegraph/motion";
import { Tooltip as I } from "@telegraph/tooltip";
import { Text as L } from "@telegraph/typography";
import { clsx as S } from "clsx";
import l from "react";
const O = {
  Root: {
    0: {
      h: "5"
    },
    1: {
      h: "6"
    },
    2: {
      h: "8"
    }
  }
}, y = {
  Root: {
    0: "1",
    1: "2",
    2: "2"
  },
  Text: {
    0: "1",
    1: "2",
    2: "2"
  }
}, u = {
  Root: {
    solid: {
      default: "gray-12",
      accent: "accent-9",
      gray: "gray-9",
      red: "red-9",
      blue: "blue-9",
      green: "green-9",
      yellow: "yellow-9",
      purple: "purple-9"
    },
    soft: {
      default: "gray-3",
      accent: "accent-3",
      gray: "gray-3",
      red: "red-3",
      blue: "blue-3",
      green: "green-3",
      yellow: "yellow-3",
      purple: "purple-3"
    }
  },
  Icon: {
    solid: {
      default: "white",
      gray: "white",
      red: "white",
      accent: "white",
      blue: "white",
      green: "white",
      yellow: "white",
      purple: "white"
    },
    soft: {
      default: "default",
      gray: "gray",
      accent: "accent",
      red: "red",
      blue: "blue",
      green: "green",
      yellow: "yellow",
      purple: "purple"
    }
  },
  Text: {
    solid: {
      default: "white",
      gray: "white",
      accent: "white",
      red: "white",
      blue: "white",
      green: "white",
      yellow: "white",
      purple: "white"
    },
    soft: {
      default: "default",
      gray: "gray",
      accent: "accent",
      red: "red",
      blue: "blue",
      green: "green",
      yellow: "yellow",
      purple: "purple"
    }
  },
  Button: {
    solid: {
      default: "default",
      gray: "gray",
      accent: "accent",
      red: "red",
      blue: "blue",
      green: "green",
      yellow: "yellow",
      purple: "purple"
    },
    soft: {
      default: "gray",
      gray: "gray",
      accent: "accent",
      red: "red",
      blue: "blue",
      green: "green",
      yellow: "yellow",
      purple: "purple"
    }
  }
}, d = l.createContext({
  size: "1",
  color: "default",
  variant: "soft"
}), m = ({
  as: r = "span",
  size: t = "1",
  color: a = "default",
  variant: o = "soft",
  className: e,
  ...i
}) => /* @__PURE__ */ n(d.Provider, { value: { size: t, color: a, variant: o }, children: /* @__PURE__ */ n(
  z,
  {
    as: r,
    align: "center",
    rounded: "2",
    display: "inline-flex",
    pl: y.Root[t],
    backgroundColor: u.Root[o][a],
    h: O.Root[t].h,
    className: S("tgph-tag", e),
    ...i,
    "data-tag": !0
  }
) }), w = ({
  as: r = "span",
  maxW: t = "40",
  style: a,
  ...o
}) => {
  const e = l.useContext(d);
  return /* @__PURE__ */ n(
    L,
    {
      as: r,
      size: e.size,
      color: u.Text[e.variant][e.color],
      weight: "medium",
      mr: y.Text[e.size],
      maxW: t,
      overflow: "hidden",
      style: {
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        ...a
      },
      ...o
    }
  );
}, x = ({ onClick: r, textToCopy: t, ...a }) => {
  const o = l.useContext(d), [e, i] = l.useState(!1);
  return l.useEffect(() => {
    if (e) {
      const c = setTimeout(() => i(!1), 2e3);
      return () => clearTimeout(c);
    }
  }, [e]), /* @__PURE__ */ n(I, { label: "Copy text", children: /* @__PURE__ */ h(
    p.Root,
    {
      onClick: (c) => {
        var s;
        r == null || r(c), i(!0), t && navigator.clipboard.writeText(t), (s = c.currentTarget) == null || s.blur();
      },
      size: o.size,
      color: u.Button[o.variant][o.color],
      variant: o.variant,
      roundedTopRight: "3",
      roundedBottomRight: "3",
      roundedTopLeft: "0",
      roundedBottomLeft: "0",
      position: "relative",
      overflow: "hidden",
      p: "2",
      ...a,
      children: [
        /* @__PURE__ */ n(
          p.Icon,
          {
            as: f.span,
            initializeWithAnimation: !1,
            animate: { y: e ? 0 : "150%", opacity: 1 },
            transition: { duration: 150, type: "spring" },
            icon: g.Check,
            alt: "Copied text",
            "aria-hidden": !e
          }
        ),
        /* @__PURE__ */ n(
          p.Icon,
          {
            as: f.span,
            initializeWithAnimation: !1,
            animate: { y: e ? "-150%" : 0, opacity: 1 },
            transition: { duration: 150, type: "spring" },
            icon: g.Copy,
            position: "absolute",
            alt: "Copy text",
            "aria-hidden": e
          }
        )
      ]
    }
  ) });
}, b = ({ ...r }) => {
  const t = l.useContext(d);
  return /* @__PURE__ */ n(
    p,
    {
      size: t.size,
      color: u.Button[t.variant][t.color],
      variant: t.variant,
      icon: { icon: g.X, alt: "close" },
      roundedTopRight: "3",
      roundedBottomRight: "3",
      roundedTopLeft: "0",
      roundedBottomLeft: "0",
      ...r
    }
  );
}, T = ({
  icon: r,
  alt: t,
  "aria-hidden": a,
  ...o
}) => {
  const e = l.useContext(d), i = t ? { alt: t } : { "aria-hidden": a };
  return /* @__PURE__ */ n(
    C,
    {
      icon: r,
      size: e.size,
      color: u.Icon[e.variant][e.color],
      mr: "1",
      roundedTopRight: "3",
      roundedBottomRight: "3",
      roundedTopLeft: "0",
      roundedBottomLeft: "0",
      ...i,
      ...o
    }
  );
}, R = ({
  color: r = "default",
  size: t = "1",
  variant: a = "soft",
  icon: o,
  onRemove: e,
  onCopy: i,
  textToCopy: c,
  textProps: s = { maxW: "40" },
  children: v,
  ...B
}) => /* @__PURE__ */ h(m, { color: r, size: t, variant: a, ...B, children: [
  o && /* @__PURE__ */ n(T, { ...o }),
  /* @__PURE__ */ n(w, { as: "span", ...s, children: v }),
  e && /* @__PURE__ */ n(b, { onClick: e, icon: { icon: g.X, alt: "Remove" } }),
  i && /* @__PURE__ */ n(x, { onClick: i, textToCopy: c })
] });
Object.assign(R, {
  Root: m,
  Button: b,
  Text: w,
  Icon: T,
  CopyButton: x
});
const D = R;
export {
  D as Tag
};
//# sourceMappingURL=index.mjs.map
